import { Component } from '@angular/core';
import { MAPSPersonHonorReceivedEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Person Honor Receiveds') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapspersonhonorreceived-form',
    templateUrl: './mapspersonhonorreceived.form.component.html'
})
export class MAPSPersonHonorReceivedFormComponent extends BaseFormComponent {
    public record!: MAPSPersonHonorReceivedEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

